import { createGlobalStyle } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

// Create global CSS - acts as base css
var GlobalStyles = createGlobalStyle(["body,html{height:100%;margin:0;padding:0;}html{font-family:", ";color:", ";}*,*:before,*:after{box-sizing:border-box;}h1,h2,h3,h4,h5,h6,p,ul,ol,button,fieldset{margin:0;padding:0;}fieldset{border:none;}button{background-color:transparent;}[data-js-focus-visible] :focus:not(:disabled):not([data-focus-visible-added]){outline:none;}body [data-focus-on-hidden]{pointer-events:initial !important;}"], themeGet('fonts.normal'), themeGet('colors.textPrimary'));

export { GlobalStyles as default };
